import { Resource } from "react-admin";
import React from "react";

export default <Resource name="events" />;



// WEBPACK FOOTER //
// ./src/resources/Events/index.js